import {
    CodeBlock, BlockType, SettingType, TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseTibbit from '@appblocks/codegeneration/Tibbits/_BaseTibbit';
import Tibbits from '@appblocks/codegeneration/Tibbits/index';

export default class Tibbit_53 extends BaseTibbit {
    constructor() {
        super();
        this.id = 'tibbit_53';
        this.name = 'Tibbit 53';
        this.fileLinks = [
            // 'ssi\\ssi.tbs',
            // 'ssi\\ssi.tbh',
        ];
        this.files = [
            'libraries/super_i2c/super_i2c.tbh',
            'libraries/super_i2c/super_i2c.tbs',
            'libraries/tibbits/tbt53/tbt53.tbh',
            'libraries/tibbits/tbt53/tbt53.tbs',
            'libraries/ssi/ssi.tbh',
            'libraries/ssi/ssi.tbs',
        ];
        const settings = [
            {
                id: 'NAME',
                name: 'Name',
                settingType: SettingType.NAME,
                dataType: TibboDataType.FLOAT,
                required: true,
                default: '',
            },
            {
                id: 'USESSI',
                name: 'Mode',
                settingType: SettingType.OPTION,
                required: true,
                readonly: true,
                default: 'NO',
                options: [
                    {
                        name: 'I2C mode',
                        value: 'YES',
                    },
                    {
                        name: 'Direct I/O (bit-banging)',
                        value: 'NO',
                    },
                ],
            },
        ];

        this.settings = this.settings.concat(settings);
    }

    getCodeBlocks() {
        const blocks: Array<CodeBlock> = [];

        if (this.project.runtime === 'simulator') {
            return [];
        }

        const socket = Tibbits.getSocket(this.getSettingValue('SOCKET'), this.project.device.id);

        const NAME = this.getSettingValue('NAME');

        blocks.push({
            location: 'boot',
            blockType: BlockType.CODE,
            template: `
    'Tibbit 53 on socket ${this.getSettingValue('SOCKET')}
    '================================================================
    if tbt53_init(YES,${this.getSettingValue('NAME')}_CLK,${this.getSettingValue('NAME')}_DATA,${this.getSettingValue('NAME')}_CHANNEL)<>OK then
        sys.debugprint("SSI channel could not be allocated, using bit banging instead.\\r\\n")
    end if
    '-----------------------------------------------------------------
        `,
        });

        blocks.push({
            location: 'GLOBAL_DECLARATIONS',
            blockType: BlockType.CODE,
            template: `
declare ${NAME}_CHANNEL as byte`,
        });

        blocks.push({
            location: 'GLOBAL_DIMS',
            blockType: BlockType.CODE,
            template: `
dim ${NAME}_CHANNEL as byte`,
        });

        blocks.push({
            location: 'GLOBAL_CONSTS',
            blockType: BlockType.CODE,
            template: `
const ${this.getSettingValue('NAME')}_CLK=${socket?.pins[0]}
const ${this.getSettingValue('NAME')}_DATA=${socket?.pins[1]}`,
        });

        blocks.push({
            location: `var_${NAME}_update`,
            blockType: BlockType.CODE,
            template: `
dim tmp_${NAME}_val as float
tbt53_get_current(tmp_${NAME}_val,${NAME}_CHANNEL)
var_${NAME}_update_completed(tmp_${NAME}_val)
`,
        });

        return blocks;
    }
}
